import React from "react"

function TestPaper() {
    const measures = ["measureOne", "measureTwo", "measureThree", "measureFour", "measureFive", "measureSix"]
    const bars = [
        {
            id: 0,
            name: "barOne",
            color: "deepPink"
        },
        {
            id: 1,
            name: "barTwo",
            color: "darkTurquoise"
        },
        {
            id: 2,
            name: "barThree",
            color: "deepPink"
        },
        {
            id: 3,
            name: "barFour",
            color: "darkTurquoise"
        },
        {
            id: 4,
            name: "barFive",
            color: "darkTurquoise"
        }
    ]
    
    const measureDots = measures.map((value, index) => {
        return <div key={index} className="measureDot" id={value}></div>
    })
    
    const horizontalBars = bars.map(bar => {
        return <div key={bar.id} className="horizontalBar" id={bar.name} style={{backgroundColor: bar.color}}></div>
    })
    
    return (
        <div className="analysisSlot">
            <div className="paperWrapper">
                <div className="measureWrapper">
                    {measureDots}
                </div>

                <div className="substanceDot"></div>
                <div id="verticalResult"></div>
                {horizontalBars}
            </div>
        </div>
    )
}

export default TestPaper